var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAtLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 .25A7.746 7.746 0 00.25 8 7.746 7.746 0 008 15.75a7.768 7.768 0 004.597-1.51.374.374 0 00.065-.538l-.159-.194a.374.374 0 00-.51-.066A6.765 6.765 0 018 14.75 6.746 6.746 0 011.25 8c0-3.73 3.019-6.75 6.75-6.75 3.701 0 6.75 2.5 6.75 6.25 0 2.277-1.65 3.383-3.627 3.383-.617 0-.74-.338-.61-1.059l1.003-5.127a.375.375 0 00-.368-.447h-.389a.375.375 0 00-.368.304c-.071.37-.089.42-.12.801-.367-.846-1.208-1.344-2.293-1.344-2.127 0-4.162 1.967-4.162 4.907 0 1.924 1.06 3.073 2.835 3.073 1.242 0 2.206-.758 2.707-1.468-.038.869.546 1.32 1.437 1.32 3.364 0 4.955-1.789 4.955-4.343C15.75 3.244 12.308.25 8 .25zM6.815 10.957c-1.146 0-1.83-.785-1.83-2.099 0-2.334 1.586-3.798 3.037-3.798 1.215 0 1.816.868 1.816 2.054 0 1.817-1.199 3.843-3.023 3.843z",
    fill: "#5268FB"
  })));
}

export default __webpack_public_path__ + "./fonts/at-light.69e0be514e2b1259f17448559348b8ec.svg";
export { SvgAtLight as ReactComponent };